/**
 * Frontend environment configuration.
 *
 * Single source of truth for the backend URL used by api.js, App.js,
 * and any other module that needs it.
 *
 * Resolution order:
 *   1. REACT_APP_BACKEND_URL env var (set at build time)
 *   2. Production default (when running on a deployed domain)
 *   3. Localhost fallback (when running on localhost)
 */

const PROD_BACKEND_URL = 'https://chatapi.aibrokerhub.com';

// Local advisor subdomains are served from acme.lvh.me (lvh.me and every
// subdomain of it resolve to 127.0.0.1), which is how a company's branded
// address is exercised without DNS. Matching only "localhost" sent those pages
// at the production backend.
const LVH = /(^|\.)lvh\.me$/;
const LOCAL_HOSTS = /^(localhost|127\.0\.0\.1|(.+\.)?lvh\.me)$/;
const isLocal = LOCAL_HOSTS.test(window.location.hostname);

// From an lvh.me page the backend is addressed as lvh.me too, not localhost.
// "Same-site" is decided by registrable domain, so localhost:8000 would be
// cross-site to acme.lvh.me and the browser would withhold the refresh cookie —
// exactly the failure the advisor subdomain is being tested for.
const DEV_BACKEND_URL = LVH.test(window.location.hostname)
  ? 'http://lvh.me:8000'
  : 'http://localhost:8000';

export const BACKEND_URL =
  process.env.REACT_APP_BACKEND_URL ||
  (isLocal ? DEV_BACKEND_URL : PROD_BACKEND_URL);

export const IS_DEV = isLocal;

// The voice WebSocket endpoint lives on the same host/port as the REST API
// (single FastAPI app) — just swap the scheme.
export const WS_BACKEND_URL = BACKEND_URL.replace(/^http/, 'ws');
